import React from 'react';
import './App.css';
import FoodOrder from "../components/FoodOrder/FoodOrder";


const App = () => {
  return(
    <div>
      <FoodOrder />
    </div>

  );
}
export default App;
